import { render } from "./AppManageTeam.vue?vue&type=template&id=33d6aee0&scoped=true"
import script from "./AppManageTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageTeam.vue?vue&type=script&setup=true&lang=js"

import "./AppManageTeam.vue?vue&type=style&index=0&id=33d6aee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6aee0"],['__file',"src/views/AppManage/AppManageTeam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33d6aee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33d6aee0', __exports__)) {
    api.reload('33d6aee0', __exports__)
  }
  
  module.hot.accept("./AppManageTeam.vue?vue&type=template&id=33d6aee0&scoped=true", () => {
    api.rerender('33d6aee0', render)
  })

}


export default __exports__